<template>
  <div class="sky-page-software-view">
    <div class="page-from-item wsp-display-flex wsp-padding-tb-12">
      <div class="page-from-label from-label"></div>
      <div class="page-from-value from-value">
        <el-button type="primary" @click="onSubmit">确定</el-button>
        <el-button @click="cancel">取消</el-button>
      </div>
    </div>
    <div class="page-from-item">
      <div class="page-from-label">桌面资源影响因子选择：</div>
      <div class="page-from-value">
        <div class="page-function-toolbar">
          <el-button icon="el-icon-refresh" class="toolbar-left" @click="refushTable"></el-button>
          <el-input
            placeholder="请输入桌面资源影响因子名称查询"
            class="toolbar-input"
            size="medium"
            v-model="searchKeyword"
            @blur="searchReq"
            @change="searchReq"
          >
            <span slot="suffix" class="el-input__suffix"
              ><span class="el-input__suffix-inner"> <i class="el-input__icon el-icon-search"></i></span>
            </span>
          </el-input>
          <el-pagination
            class="toolbar-right"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            @prev-click="handelPrev"
            @next-click="handelNext"
            :page-sizes="[5, 10, 20, 50, 100]"
            layout="total,sizes,prev,sp,next"
            :current-page="page"
            :page-size="pageSize"
            :total="pageTotal"
          >
          </el-pagination>
        </div>
        <el-table
          ref="table"
          height="700"
          :border="true"
          :data="listData"
          :show-header="true"
          :column-drag-sortable="false"
          class="sky-host-dist"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" :selectable="selectableRow"> </el-table-column>
          <el-table-column label="名称" prop="name" show-overflow-tooltip />
          <el-table-column label="软件版本" prop="softVersion" show-overflow-tooltip />
          <el-table-column label="类型" prop="typeDesc" width="120"></el-table-column>
          <el-table-column label="素材大小" prop="materialDesc" show-overflow-tooltip />
          <el-table-column label="CPU主频" prop="cpuSpeed" show-overflow-tooltip />
          <el-table-column label="CPU核数" prop="cpuCore" show-overflow-tooltip />
          <el-table-column label="显存大小" prop="videoMemory" show-overflow-tooltip />
          <el-table-column label="内存大小" prop="memory" show-overflow-tooltip />

          <el-table-column label="系统盘大小" prop="systemDiskSize" show-overflow-tooltip />
          <el-table-column label="数据盘大小" prop="dataDiskSize" show-overflow-tooltip />
          <el-table-column label="iops" prop="iops" show-overflow-tooltip />
          >
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Button, Pagination, RadioGroup, RadioButton, Input, Tag } from 'element-ui'

import dictionary from '../../utils/dictionary'

import { getDesktopElementList } from '@/api/desktopElement'

// import lang from '@/lang'
export default {
  name: 'SkyDesktopElementTable',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button,
    [Pagination.name]: Pagination,
    [RadioGroup.name]: RadioGroup,
    [RadioButton.name]: RadioButton,
    [Input.name]: Input,
    [Tag.name]: Tag
  },
  props: {
    params: {
      type: Object,
      default: function() {
        return {}
      }
    },
    selectedItemArr: {
      type: Array
    }
  },
  data: function() {
    return {
      selectItem: null,
      dictionary: dictionary,
      dialogVisible: false,
      shwoFunViewDetail: {},
      listData: [],
      selectScene: {},
      selectSceneId: null,
      selectFuntion: [],
      searchKeyword: '',
      pageTotal: 0,
      pageSize: 20,
      reqParmas: {
        exactMatchArr: [],
        matchArr: [
          {
            type: 'EXACT',
            fieldName: 'type',
            valueArr: ['SCENE_CONFIG'],
            matchRule: 'NEQ'
          }
        ],
        page: 0,
        limit: 20
      },
      page: 1
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.reqParmas.page = this.page - 1
      this.reqParmas.limit = this.pageSize
      getDesktopElementList(this.reqParmas).then(res => {
        this.listData = res.data.content.itemArr
        var idList = this.selectedItemArr.map(item => {
          return item.id
        })
        this.$nextTick(() => {
          this.listData.forEach(row => {
            if (idList.includes(row.id)) {
              this.$refs.table.toggleRowSelection(row, true)
            } else {
              this.$refs.table.toggleRowSelection(row, false)
            }
          })
        })

        this.pageTotal = res.data.content.total
      })
    },
    refushTable() {
      this.getData()
    },
    searchReq() {
      if (this.searchKeyword !== '') {
        //
        const exists = this.reqParmas.matchArr.some(obj => obj.fieldNameArr)
        if (exists) {
          for (const iterator of this.reqParmas.matchArr) {
            if (iterator.fieldNameArr) {
              iterator.value = this.searchKeyword
            }
          }
        } else {
          this.reqParmas.matchArr.push({
            type: 'FUZZY',
            fieldNameArr: ['name'],
            value: this.searchKeyword,
            matchRule: 'FULL'
          })
        }
      } else {
        for (let index = 0; index < this.reqParmas.matchArr.length; index++) {
          const element = this.reqParmas.matchArr[index]
          if (element.fieldNameArr) {
            this.reqParmas.matchArr.splice(index, 1)
          }
        }
      }

      this.getData()
    },
    onSubmit() {
      if (this.selectItem.length > 0) {
        this.$emit('addSelect', { select: this.selectItem })
      } else {
        this.$store.dispatch('OpenNotification', { message: '请至少选择一个桌面影响因子', type: 'error' })
      }
    },
    selectableRow(row, index) {
      var idList = this.selectedItemArr.map(item => {
        return item.id
      })
      return !idList.includes(row.id)
    },
    handleSelectionChange(val) {
      this.selectItem = val
    },
    handleCloseDrawer() {
      this.shwoFunViewDetail = {}
      this.dialogVisible = false
    },
    cancel() {
      this.$parent.$parent.closerDrawer()
    },
    // size 变更 每页条数
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    //
    handleCurrentChange() {},
    handelPrev() {
      this.page -= 1
      this.getData()
    },
    handelNext() {
      this.page += 1
      this.getData()
    }
  }
}
</script>

<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(page-software-view) {
  height: 100%;
  .page-from-item {
    padding: 0 6px;
    line-height: 28px;
    .page-from-item-label {
      font-size: 14px;
      font-weight: 600;
    }
    .from-value {
      padding-left: 12px;
    }
    .page-from-item-value {
    }
  }
  .page-function-toolbar {
    .toolbar-input {
      width: 39%;
    }
    .toolbar-left {
      float: left;
    }
    .toolbar-right {
      float: right;
    }
  }
}
</style>
